module.exports = __webpack_public_path__ + "static/media/corrin.de2eb0ce.png";